import { connect } from 'react-redux';

import { StateType } from '../../../../types';
import { selectRequestInfo } from '../../../../redux/selectors/request';
import { selectUserType } from '../../../../redux/selectors/auth';

const mapStateToProps = (state: StateType) => ({
  requestInfo: selectRequestInfo(state),
  userType: selectUserType(state),
});

export default connect(mapStateToProps);
